import React from "react";
import { Layers } from "lucide-react";
import { Button } from "../../components/Button";

export const WorkflowTemplateHeader = ({
    activeTab,
    setActiveTab,
    selectedCategory,
    setSelectedCategory,
    setShowCreateTemplate,
    workflowTemplates,
}) => {
    const categories = [
        { value: "", label: "All Categories" },
        { value: "USER_DEFINED_TEMPLATE", label: "User Defined" },
        { value: "GST_COMPLIANCE", label: "GST Compliance" },
        { value: "TDS_MANAGEMENT", label: "TDS Management" },
        { value: "AUDIT_AND_ASSURANCE", label: "Audit & Assurance" },
        { value: "CLIENT_ONBOARDING", label: "Client Onboarding" },
    ];

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-2">
            {/* Top Row */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-0 space-y-3 md:space-y-0">
                <h1 className="text-2xl font-bold text-gray-900">
                    Workflow Templates Management
                </h1>
                <div className="flex space-x-3">
                    <Button
                        label="Create Template"
                        onClick={() => setShowCreateTemplate(true)}
                    />
                </div>
            </div>

            {/* Category Filter */}
            {/* <div className="flex flex-col md:flex-row md:items-center md:space-x-4 mb-6 space-y-3 md:space-y-0">
                <div className="relative w-full md:w-64">
                    <Layers className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                    <select
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                        className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full"
                    >
                        {categories.map((cat) => (
                            <option key={cat.value} value={cat.value}>
                                {cat.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="text-sm text-gray-600">
                    {selectedCategory
                        ? `Showing templates for ${categories.find((c) => c.value === selectedCategory)?.label
                        }`
                        : "Showing all templates"}
                </div>
            </div> */}

            {/* Tabs */}
            <div className="border-b border-gray-200">
                <nav className="-mb-px flex space-x-8 overflow-x-auto">
                    {[
                        { id: "templates", label: "Templates", count: workflowTemplates?.length || 0 },
                        { id: "categories", label: "By Category", count: 0 },
                        { id: "assigned", label: "Instantiated Workflows", count: 0 },
                    ].map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`py-2 px-1 border-b-2 font-medium text-sm ${activeTab === tab.id
                                    ? "border-blue-500 text-blue-600"
                                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                                }`}
                        >
                            {tab.label}
                            {tab.count > 0 && (
                                <span className="ml-2 bg-gray-100 text-gray-900 py-0.5 px-2 rounded-full text-xs">
                                    {tab.count}
                                </span>
                            )}
                        </button>
                    ))}
                </nav>
            </div>
        </div>
    );
};
